import { fptiPageNames } from '@common/fpti';
import { BASE_TAGS } from './constants';

export default (pageName: string | undefined, eventName: string, event?: string) => {
  const page = fptiPageNames[pageName || ''];
  if (event) {
    return {
      ...BASE_TAGS,
      page,
      event_name: eventName,
      e: event,
      event_type: event
    };
  }
  return {
    ...BASE_TAGS,
    page,
    action: eventName
  };
};
